<template>
    <div class="l-main">
        <div class="l-main-content container-xl bg-white-shadow" style="max-width: 1480px;">
            <div class="row p-left p-right p-top p-bottom">
                <div class="input">
                    <i class="search icon"></i>
                    <input v-on:keyup.enter="search_profile" type="text" placeholder="Enter phone number..." v-model="searchProfile">
                </div>
            </div>
        </div>
        <div class="l-main-content padded" v-show="profile_data">
    
            <div class="card bg-white">
    
                <div class="row vertical-middle">
                    <div class="col-6 vertical-middle">
                        <h4>{{name}}</h4>
                        <h3>{{phone}}</h3>
                        <h3>{{ email }}</h3>
                        <h3>{{ statusProfile | formartStatus }}</h3>
                        <div class="divider"></div>
                        <h5>Balance</h5>
                        <h4><strong>Ksh. {{balance | formatAmount}}</strong></h4>
    
    
                    </div>
                    <div class="col-6 border-left padding-left-md">
                        <table class="table clean">
                            <tbody>
                                <tr>
                                    <td>Deposits</td>
                                    <td class="text-right">Ksh. {{deposit | formatAmount}}</td>
                                </tr>
    
                                <tr>
                                    <td>Bonus</td>
                                    <td class="text-right">Ksh. {{bonus | formatAmount}}</td>
                                </tr>
                                <tr>
                                    <td>Withdrawals</td>
                                    <td class="text-right">Ksh. {{withdraw | formatAmount}}</td>
                                </tr>
                                <tr>
                                    <td v-if="statusProfile != -5">
                                        <b-button class="mt-3" variant="outline-danger" block @click="showModal">Block Account</b-button>
                                    </td>
                                    <td v-if="statusProfile == -5">
                                        <b-button class="mt-2" variant="outline-warning" block @click="showModal">Activated Account</b-button>
    
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <b-tabs content-class="mt-3 " v-show="profile_data" class="p-left p-right card bg-white" @input="onTabChange">
            <b-tab title="Deposit">
                <div class="row">
                    <div class="col-8">
    
                        <div class="input" style="margin-top: 10px;">
                            <i class="search icon"></i>
                            <input v-on:keyup.enter="searchRecord" type="text" placeholder="Enter M-Pesa Reference" v-model="search_match">
                        </div>
                    </div>
                    <div class="col-4 text-right">
                        <b-button class="mt-3" variant="outline-danger" block id="commentBTN" @click="showTicketModal(1,1)"><i class="fas fa-reply-all"></i> Create Deposit Tickets</b-button>
                    </div>
                </div>
                <div class="row padded">
                    <loader v-show='loading' />
                    <vuetable ref="vuetableDeposit" class="table table-bordered table-striped" :http-options="httpOptions" api-url="https://interactiveapi.chezagame.com/portal/v1/view/mpesa/deposit" :fields="columnsDeposit" :css="css.table" :sort-order="sortOrder"
                        track-by="paybill" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationDataDeposit" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                    </vuetable>
                </div>
                <div class="vuetable-pagination row">
                    <div class="col text-left">
                        <vuetable-pagination-info ref="paginationInfoDeposit"></vuetable-pagination-info>
                    </div>
                    <div class="col">
                        <vuetable-pagination ref="paginationDeposit" @vuetable-pagination:change-page="onChangePageDeposit">
                        </vuetable-pagination>
                    </div>
                </div>
            </b-tab>
            <b-tab title="Transactions">
                <div class="row padded">
                    <loader v-show='loading' />
                    <vuetable class="table table-bordered table-striped" ref="vuetableTransactions" :http-options="httpOptions" api-url="https://interactiveapi.chezagame.com/portal/v1/view/transactions" :fields="columnsTrans" :css="css.table" :sort-order="sortOrder"
                        track-by="paybill" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationDataTransactions" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                    </vuetable>
                </div>
                <div class="vuetable-pagination row">
                    <div class="col text-left">
                        <vuetable-pagination-info ref="paginationInfoTransactions"></vuetable-pagination-info>
                    </div>
                    <div class="col">
                        <vuetable-pagination ref="paginationTransactions" @vuetable-pagination:change-page="onChangePageTransactions">
                        </vuetable-pagination>
                    </div>
                </div>
            </b-tab>
            <b-tab title="Withdraws">
                <div class="row padded">
                    <loader v-show='loading' />
                    <vuetable ref="vuetableWithdraws" class="table table-bordered table-striped" :http-options="httpOptions" api-url="https://interactiveapi.chezagame.com/portal/v1/view/withdraws" :fields="columnsWithdraw" :css="css.table" :sort-order="sortOrder"
                        track-by="paybill" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationDataWithdraws" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                        <div slot="status" slot-scope="props">
                            <div :class="{'text-green':props.rowData.response_code== 0,'text-orange':props.rowData.response_code== 1, 'text-red': props.rowData.response_code== 21, 'text-red': props.rowData.response_code== '-5' ,'text-red': props.rowData.response_code== 2001 }"><strong>{{props.rowData.response_code | formatStatusPayment}}</strong></div>
                        </div>
                        <div slot="action" slot-scope="props">
                            <b-button class="mt-3" variant="outline-danger" @click="showTicketWithdrawModal(2,2,props.rowData.id)" v-if="props.rowData.response_code!= 0 && props.rowData.response_code!= -5 && props.rowData.response_code!= 1"><i class="fas fa-reply-all"></i></b-button>
                        </div>
    
                    </vuetable>
    
                </div>
                <div class="vuetable-pagination row">
                    <div class="col text-left">
                        <vuetable-pagination-info ref="paginationInfoWithdraws"></vuetable-pagination-info>
                    </div>
                    <div class="col">
                        <vuetable-pagination ref="paginationWithdraws" @vuetable-pagination:change-page="onChangePageWithdraws">
                        </vuetable-pagination>
                    </div>
                </div>
    
            </b-tab>
            <b-tab title="SpinWheel">
                <div class="row padded">
                    <loader v-show='loading' />
                    <vuetable ref="vuetableSpinWheel" class="table table-bordered table-striped" :http-options="httpOptions" api-url="https://interactiveapi.chezagame.com/v1/spinwheel/ussd/bets/view" :fields="columnsSpinWheel" :css="css.table" :sort-order="sortOrder"
                        track-by="paybill" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationDataSpinWheel" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                    </vuetable>
                </div>
                <div class="vuetable-pagination row">
                    <div class="col text-left">
                        <vuetable-pagination-info ref="paginationInfoSpinWheel"></vuetable-pagination-info>
                    </div>
                    <div class="col">
                        <vuetable-pagination ref="paginationSpinWheel" @vuetable-pagination:change-page="onChangePageSpinWheel">
                        </vuetable-pagination>
                    </div>
    
                </div>
    
            </b-tab>
            <b-tab title="Aviator">
    
                <div class="row padded">
                    <vuetable ref="vuetableAviator" class="table table-bordered table-striped" :http-options="httpOptions" api-url="https://interactiveapi.chezagame.com/v1/aviator/ussd/bets/view" :fields="columnsAviator" :css="css.table" :sort-order="sortOrder" track-by="paybill"
                        :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationDataAviator" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                    </vuetable>
                </div>
                <div class="vuetable-pagination row">
                    <div class="col text-left">
                        <vuetable-pagination-info ref="paginationInfoAviator"></vuetable-pagination-info>
                    </div>
                    <div class="col">
                        <vuetable-pagination ref="paginationAviator" @vuetable-pagination:change-page="onChangePageAviator">
                        </vuetable-pagination>
                    </div>
                </div>
    
    
            </b-tab>
            <b-tab title="Pickbox">
                <div class="row padded">
                    <vuetable ref="vuetablePickbox" class="table table-bordered table-striped" :http-options="httpOptions" api-url="https://interactiveapi.chezagame.com/v1/pickbox/ussd/bets/view" :fields="columnsPickbox" :css="css.table" :sort-order="sortOrder" track-by="paybill"
                        :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationDataPickbox" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
    
                    </vuetable>
                </div>
    
                <div class="vuetable-pagination row">
                    <div class="col text-left">
                        <vuetable-pagination-info ref="paginationInfoPickbox"></vuetable-pagination-info>
                    </div>
                    <div class="col">
                        <vuetable-pagination ref="paginationPickbox" @vuetable-pagination:change-page="onChangePagePickbox">
                        </vuetable-pagination>
                    </div>
                </div>
            </b-tab>
            <b-tab title="Outbox">
                <div class="row padded">
                    <vuetable ref="vuetableOutbox" class="table table-bordered table-striped" :http-options="httpOptions" api-url="https://interactiveapi.chezagame.com/portal/v1/view/outbox" :fields="columnsOutbox" :css="css.table" :sort-order="sortOrder" track-by="paybill"
                        :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationDataOutbox" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                    </vuetable>
                </div>
    
                <div class="vuetable-pagination row">
                    <div class="col text-left">
                        <vuetable-pagination-info ref="paginationInfoOutbox"></vuetable-pagination-info>
                    </div>
                    <div class="col">
                        <vuetable-pagination ref="paginationOutbox" @vuetable-pagination:change-page="onChangePageOutbox">
                        </vuetable-pagination>
                    </div>
                </div>
            </b-tab>
            <b-tab title="Tickets">
                <div class="row padded">
                    <vuetable ref="vuetableTickets" class="table table-bordered table-striped" :http-options="httpOptions" api-url="https://interactiveapi.chezagame.com/tickets/v1/view" :fields="columnsTickets" :css="css.table" :sort-order="sortOrderTickets" track-by="tickets"
                        :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationDataTickets" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                        <div slot="status" slot-scope="props">
                            <strong :class="{'text-green':props.rowData.ticket_status_id== 3,'text-orange': props.rowData.ticket_status_id == 2, 'text-red': props.rowData.ticket_status_id == 1}">{{props.rowData.ticket_status_id | formartTicketStatus}}</strong>
                        </div>
                        <div slot="sla_datetime" slot-scope="props">
                            <strong>{{props.rowData.sla_datetime | format_date_from}}</strong>
                        </div>
                    </vuetable>
                </div>
    
                <div class="vuetable-pagination row">
                    <div class="col text-left">
                        <vuetable-pagination-info ref="paginationInfoTickets"></vuetable-pagination-info>
                    </div>
                    <div class="col">
                        <vuetable-pagination ref="paginationTickets" @vuetable-pagination:change-page="onChangePageTickets">
                        </vuetable-pagination>
                    </div>
                </div>
            </b-tab>
        </b-tabs>
        <b-modal ref="my-modal" hide-footer title="Account Status Update">
            <div class="d-block text-center">
                <h3>{{ actionStatus }} Account</h3>
            </div>
            <div class="alert alert-warning alert-dismissible fade show" role="alert" v-show="updateStatus">
                {{ updateMessage }}
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
            <b-button class="mt-3" variant="outline-success" block @click="updateProfileStatus">Proceed to {{ actionStatus }} </b-button>
            <b-button class="mt-2" variant="outline-danger" block @click="hideModal">Cancel</b-button>
        </b-modal>
        <b-modal ref="create-ticket-modal" hide-footer title="Create Ticket">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-6">
                    <label>Ticket Type*</label>
                    <select v-model="ticket_type_id" @change="handleTicketSub">
                                        <option value>Select Ticket Type</option>
                                        <option v-for="(n,index) in ticketTypeList" :key="index+1" :value="n.ticket_type_id"> {{n.ticket_type}}</option>
                                </select>
                </div>
                <div class="col-6">
                    <label>Ticket Type*</label>
                    <select v-model="ticket_sub_type_id">
                                        <option value>Select Ticket Sub Type</option>
                                        <option v-for="(n,index) in ticketSubType" :key="index+1" :value="n.ticket_type_sub_id"> {{n.ticket_type_sub}}</option>
                                </select>
                </div>
                <div class="col-6">
                    <label>Ticket Priority*</label>
                    <select v-model="ticket_priority_id">
                                        <option value>Select Ticket Priority</option>
                                        <option v-for="(n,index) in ticketPriorityList" :key="index+1" :value="n.priority_id"> {{n.priority}}</option>
                                </select>
                </div>
    
                <div class="col-6">
                    <label>Customer Mobile</label>
                    <input type="text" v-model="searchProfile" placeholder="Enter Mobile">
                </div>
                <div class="col-6" v-show="Hasreference">
                    <label>Date</label>
                    <input type="date" v-model="selectedDate">
                </div>
                <div class="col-6" v-show="Hasreference">
                    <label>Time</label>
                    <input type="time" v-model="selectedTime">
                </div>
                <div class="col-12" v-show="Hasreference">
                    <label>M-Pesa Reference</label>
                    <input type="text" v-model="ticketReference" placeholder="Enter Ticket Reference">
                </div>
                <div class="col-6" v-show="Hasreference">
                    <label>Account</label>
                    <input type="text" v-model="BillRefNumber" placeholder="Enter Account">
                </div>
                <div class="col-6" v-show="Hasreference">
                    <label>Amount</label>
                    <input type="text" v-model="billAmount" placeholder="Enter Amount">
                </div>
                <div class="col-12">
                    <label>Description</label>
                    <textarea rows="4" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="description" required />
                </div>
            </div>
            <b-button class="mt-3" variant="outline-success" block @click="createTicketType" id="createTicketType">Create Ticket Type</b-button>
            <b-button class="mt-2" variant="outline-danger" block @click="hideTicketModal">Cancel</b-button>
        </b-modal>
    
    </div>
</template>

<style src="vue-slim-tabs/themes/default.css">

</style>

<script>
import { Tabs, Tab } from 'vue-slim-tabs'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import numeral from "numeral";
import moment from 'moment'
import _ from "lodash";
import loader from "@/components/loader"
import tableCss from "@/components/css.js";
import store from "../store";
import $ from 'jquery';


export default {

    name: 'profiles',

    components: {

        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        loader,
        Tabs,
        Tab

    },
    data() {
        return {
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            ticket_type_id: 1,
            ticket_sub_type_id: "",
            ticket_priority_id: 3,
            ticketReference: "",
            Hasreference: false,
            ticketDate: "",
            blacklist: "",
            profile_data: false,
            searchProfile: "",
            name: "",
            phone: "",
            email: "",
            statusProfile: "",
            balance: 0,
            bonus: 0,
            withdraw: 0,
            tickets: 0,
            deposit: 0,
            css: tableCss,
            selectedTab: "default",
            actionStatus: "Block",
            userStatus: 51,
            loading: true,
            selected_data: {},
            columnsPickbox: [{
                    name: "pickbox_bet_id",
                    title: 'Bet ID',
                    sortField: 'pickbox_bet_id',
                },
                {
                    name: 'pickbox_game',
                    title: 'Bet Type',
                    sortField: 'pickbox_game',
                    titleClass: '',
                    dataClass: ''
                },
                {
                    name: 'box_number_stake',
                    title: 'Box Number Stake',
                    sortField: 'box_number_stake',
                    titleClass: '',
                    dataClass: ''
                },
                {
                    name: 'msisdn',
                    title: 'Phone',
                    sortField: 'msisdn',
                    titleClass: '',
                    dataClass: '',

                },
                {
                    name: "payment_reference",
                    title: 'Payment Reference',
                    sortField: 'payment_reference',
                },
                {
                    name: "stake_amount",
                    title: 'Stake Amount',
                    sortField: 'stake_amount',
                },
                {
                    name: 'amount_won',
                    title: 'Won Amount',
                    sortField: 'amount_won'

                },
                {
                    name: 'status_description',
                    title: 'Status',
                    sortField: 'status_description',
                    titleClass: '',
                    dataClass: ''

                },

                {
                    name: 'created',
                    title: 'Date',
                    sortField: 'created',
                    titleClass: '',
                    dataClass: ''
                },


            ],
            columnsSpinWheel: [{
                    name: "spin_wheel_bet_id",
                    title: 'Bet ID',
                    sortField: 'spin_wheel_bet_id',
                },
                {
                    name: "betSlipID",
                    title: 'BetSlip ID',
                    sortField: 'betSlipID',
                },

                {
                    name: 'msisdn',
                    title: 'Phone',
                    sortField: 'msisdn',
                    titleClass: '',
                    dataClass: '',

                },
                {
                    name: "payment_reference",
                    title: 'Payment Reference',
                    sortField: 'payment_reference',
                },
                {
                    name: "stake_amount",
                    title: 'Stake Amount',
                    sortField: 'stake_amount',
                },
                {
                    name: 'won_amount',
                    title: 'Won Amount',
                    sortField: 'won_amount'

                },
                {
                    name: 'status_description',
                    title: 'Status',
                    sortField: 'status_description',
                    titleClass: '',
                    dataClass: ''

                },
                {
                    name: 'spin_betslip_name',
                    title: 'Bet Type',
                    sortField: 'spin_betslip_name',
                    titleClass: '',
                    dataClass: ''
                },
                {
                    name: 'created',
                    title: 'Date',
                    sortField: 'created',
                    titleClass: '',
                    dataClass: ''
                },


            ],
            columns: [{
                    name: 'first_name',
                    title: '<span class="orange glyphicon glyphicon-user"></span> First Name',
                    sortField: 'first_name',
                    titleClass: '',
                    dataClass: ''
                },
                {
                    name: 'last_name',
                    title: 'Last Name',
                    sortField: 'last_name',
                    titleClass: '',
                    dataClass: '',

                },
                {
                    name: "msisdn",
                    title: 'Phone',
                    sortField: 'msisdn',
                },
                {
                    name: "ticket_amount",
                    title: 'Amount',
                    sortField: 'ticket_amount',
                },
                {
                    name: 'created_by',
                    title: 'Source',
                    sortField: 'created_by',
                    titleClass: 'center aligned',
                    dataClass: 'center aligned'

                },
                {
                    name: 'created',
                    title: 'Date',
                    sortField: 'created',
                    titleClass: '',
                    dataClass: ''

                },

            ],
            columnsTrans: [

                {
                    name: 'mobile_number',
                    title: 'Phone',
                    sortField: 'mobile_number',
                    titleClass: '',
                    dataClass: '',

                },
                {
                    name: "transaction_date",
                    title: 'Date',
                    sortField: 'transaction_date',
                    callback: 'createdAt'
                },
                {
                    name: "amount",
                    title: 'Amount',
                    sortField: 'amount',
                },
                {
                    name: "balance",
                    title: 'Balance',
                    sortField: 'balance',
                },
                {
                    name: 'source',
                    title: 'Source',
                    sortField: 'source',
                    titleClass: 'center aligned',
                    dataClass: 'center aligned'

                },
                {
                    name: 'transaction_type',
                    title: 'Type',
                    sortField: 'transaction_type',
                    titleClass: '',
                    dataClass: ''

                },
                {
                    name: 'reference_name',
                    title: 'Reference',
                    sortField: 'reference_name',
                    titleClass: '',
                    dataClass: ''
                },
                {
                    name: "transaction_reference_id",
                    title: 'Reference ID',
                    sortField: 'transaction_reference_id',
                },
                {
                    name: "narration",
                    title: 'Narration',
                    sortField: 'narration',
                },

            ],
            columnsDeposit: [

                {
                    name: 'mpesa_msisdn',
                    title: 'Phone',
                    sortField: 'mpesa_msisdn',
                    titleClass: '',
                    dataClass: '',

                },
                {
                    name: "mpesa_code",
                    title: 'M-Pesa Reference',
                    sortField: 'mpesa_code',
                    callback: 'createdAt'
                },
                {
                    name: "mpesa_sender",
                    title: 'Sender',
                    sortField: 'mpesa_sender',
                },
                {
                    name: 'mpesa_amount',
                    title: 'Amount',
                    sortField: 'mpesa_amount',
                    titleClass: 'center aligned',
                    dataClass: 'center aligned'

                },
                {
                    name: 'mpesa_account',
                    title: 'Account',
                    sortField: 'mpesa_account',
                    titleClass: '',
                    dataClass: ''

                },
                {
                    name: 'paybill',
                    title: 'Paybill',
                    sortField: 'paybill',
                    titleClass: '',
                    dataClass: ''
                },
                {
                    name: "org_balance",
                    title: 'Balance',
                    sortField: 'org_balance',
                },
                {
                    name: "created",
                    title: 'Date',
                    sortField: 'created',
                },

            ],
            columnsWithdraw: [{
                    name: 'id',
                    title: 'Reference#',
                    sortField: 'id',
                    titleClass: '',
                    dataClass: '',

                },
                {
                    name: "mpesa_transaction_id",
                    title: 'M-Pesa Reference',
                    sortField: 'mpesa_transaction_id'
                },
                {
                    name: "msisdn",
                    title: 'Mobile',
                    sortField: 'msisdn',
                },
                {
                    name: 'withdraw_amount',
                    title: 'Withdraw Amount',
                    sortField: 'withdraw_amount',

                },
                {
                    name: 'charges',
                    title: 'Charges',
                    sortField: 'charges'

                },
                {
                    name: 'status',
                    title: 'Status',
                    sortField: 'status',
                    titleClass: '',
                    dataClass: ''
                },
                {
                    name: "ip_address",
                    title: 'IP',
                    sortField: 'ip_address',
                },
                {
                    name: "response_status",
                    title: 'Status Description',
                    sortField: 'response_status',
                },
                {
                    name: "b2c_balance",
                    title: 'Balance',
                    sortField: 'b2c_balance',
                },
                {
                    name: "created_at",
                    title: 'Date',
                    sortField: 'created_at',
                },
                {
                    name: "action",
                    title: "Action"
                }

            ],
            columnsOutbox: [{
                    name: 'msisdn',
                    title: '<span class="orange glyphicon glyphicon-user"></span>Phone',
                    sortField: 'msisdn',
                    titleClass: '',
                    dataClass: ''
                },

                {
                    name: 'short_code',
                    title: 'Shortcode',
                    sortField: 'short_code',
                    titleClass: '',
                    dataClass: '',

                },

                {
                    name: "description",
                    title: 'Status',
                    sortField: 'description',
                },

                {
                    name: "created",
                    title: 'Sent On',
                    sortField: 'created',
                },

                {
                    name: 'message',
                    title: 'Message',
                    sortField: 'message',
                    titleClass: '',
                    dataClass: "center aligned",
                    width: "15%",
                },

            ],
            columnsAviator: [{
                    name: "avaitor_bet_id",
                    title: 'Bet ID',
                    sortField: 'avaitor_bet_id',
                },
                {
                    name: 'avaitor_game',
                    title: 'Bet Type',
                    sortField: 'avaitor_game',
                    titleClass: '',
                    dataClass: ''
                },

                {
                    name: 'msisdn',
                    title: 'Phone',
                    sortField: 'msisdn',
                    titleClass: '',
                    dataClass: '',

                },
                {
                    name: "payment_reference",
                    title: 'Payment Reference',
                    sortField: 'payment_reference',
                },
                {
                    name: "stake_amount",
                    title: 'Stake Amount',
                    sortField: 'stake_amount',
                },
                {
                    name: 'amount_won',
                    title: 'Won Amount',
                    sortField: 'amount_won'

                },
                {
                    name: 'status_description',
                    title: 'Status',
                    sortField: 'status_description',
                    titleClass: '',
                    dataClass: ''

                },

                {
                    name: 'created',
                    title: 'Date',
                    sortField: 'created',
                    titleClass: '',
                    dataClass: ''
                },


            ],
            columnsTickets: [{
                    name: "ticket_id",
                    title: 'Ticket ID',
                    sortField: "ticket_id",
                    titleClass: "center aligned",
                    dataClass: "center aligned"
                },

                {
                    name: "msisdn",
                    title: "Customers",
                    sortField: "msisdn",
                    titleClass: "",
                    dataClass: ""
                },

                {
                    name: "priority",
                    title: "Priority",
                    sortField: "priority",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "priority_sla_hour",
                    title: "SLA (Hour)",
                    sortField: "priority_sla_hour",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "sla_datetime",
                    title: "SLA Date",
                    sortField: "sla_datetime",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "ticket_type",
                    title: "Type",
                    sortField: "ticket_type",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "status",
                    title: "Status",
                    sortField: "status",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "caller",
                    title: "Created By",
                    sortField: "caller",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "ticket_brief",
                    title: "Brief",
                    sortField: "ticket_brief",
                    titleClass: "",
                    dataClass: ""
                },


                {
                    name: "created_at",
                    title: "Date",
                    sortField: "created_at",
                    callback: "createdAt"
                },
                {
                    name: "action",
                    title: "Action",
                    resizable: true
                }
            ],
            range: '',
            search_match: '',
            loadOnStart: true,
            sortOrderW: [{
                field: 'created_at',
                direction: 'desc'
            }],
            sortOrder: [{
                field: 'created',
                direction: 'desc'
            }],
            sortOrderTickets: [{
                field: 'created_at',
                direction: 'desc'
            }],
            is_partial_resulting: false,
            moreParams: {
                start: '',
                filter: '',
                end: ''
            },
            updateStatus: false,
            updateMessage: "",
            ticketTypeList: [],
            ticketSubType: [],
            ticketPriorityList: [],
            selectedDate: "",
            selectedTime: "",
            description: "",
            BillRefNumber: "",
            billAmount: 0.00,
            errorcreateStatus: false,
            errorsMessage: "",
            searchpayment: ""
        }
    },
    watch: {
        data(newVal, oldVal) {
            this.$refs.vuetableDeposit.refresh();
        },
        range() {

            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format('YYYY-MM-DD');
            end = moment(end).format('YYYY-MM-DD');
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetableDeposit.refresh();
        },
        searchProfile() {
            let vm = this
            vm.$refs.vuetableDeposit.refresh();
        }
    },
    mounted() {
        var vm = this;
        var start = moment();
        var end = moment();



        function cb(start, end) {
            vm.dateFilter(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
            $('input[name="dates"]').val(start.format('D MMMM, YYYY') + ' - ' + end.format('D MMMM, YYYY'));
        }
        cb(start, end);
        vm.selectedDate = moment().format('YYYY-MM-DD');

        vm.getTypeList()
        vm.getPriorityList()
    },
    methods: {
        handleTicketSub() {
            let vm = this
            if (vm.ticket_type_id == 1) {
                vm.Hasreference = true
            } else {
                vm.Hasreference = false
            }
            $.get({
                url: store.state.rootUrl + 'tickets/v1/view/sub/type',
                type: "get",
                async: true,
                data: {
                    "per_page": 30,
                    "ticketTypeID": vm.ticket_type_id
                },
                crossDomain: true,
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                success: function(response, status, jQxhr) {
                    vm.isLoading = false;

                    vm.ticketSubType = response.data
                    console.log("SubID " + JSON.stringify(response.data[0].ticket_type_sub_id))


                },
                error: function(jQxhr, status, error) {
                    vm.isLoading = false;
                    if (jQxhr.responseJSON.data.code == 401) {
                        var errorMessage = jQxhr.responseJSON.data.message;

                        vm.$router.push({
                            name: 'login'
                        });
                    } else {
                        console.log("Error: " + jQxhr.responseJSON.statusDescription)
                    }
                }
            });
        },
        onTabChange(newTabIndex) {
            if (newTabIndex == 0) {
                this.$refs.vuetableDeposit.refresh();
            }
            if (newTabIndex == 1) {
                this.$refs.vuetableTransactions.refresh();
            }
            if (newTabIndex == 2) {
                this.$refs.vuetableWithdraws.refresh();
            }
            if (newTabIndex == 3) {
                this.$refs.vuetableSpinWheel.refresh();
            }
            if (newTabIndex == 4) {
                this.$refs.vuetableAviator.refresh();
            }
            if (newTabIndex == 5) {
                this.$refs.vuetablePickbox.refresh();
            }
            if (newTabIndex == 6) {
                this.$refs.vuetableOutbox.refresh();
            }
            if (newTabIndex == 7) {
                this.$refs.vuetableTickets.refresh();
            }
        },
        getPriorityList() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'tickets/v1/view/priority',
                type: "get",
                async: true,
                data: {
                    "per_page": 20
                },
                crossDomain: true,
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                success: function(response, status, jQxhr) {
                    vm.isLoading = false;

                    vm.ticketPriorityList = response.data

                },
                error: function(jQxhr, status, error) {
                    vm.isLoading = false;
                    if (jQxhr.responseJSON.data.code == 401) {
                        var errorMessage = jQxhr.responseJSON.data.message;

                        vm.$router.push({
                            name: 'login'
                        });
                    } else {
                        console.log("Error: " + jQxhr.responseJSON.statusDescription)
                    }
                }
            });


        },
        getTypeList() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'tickets/v1/view/type',
                type: "get",
                async: true,
                data: {
                    "per_page": 20
                },
                crossDomain: true,
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                success: function(response, status, jQxhr) {
                    vm.isLoading = false;

                    vm.ticketTypeList = response.data

                },
                error: function(jQxhr, status, error) {
                    vm.isLoading = false;
                    if (jQxhr.responseJSON.data.code == 401) {
                        var errorMessage = jQxhr.responseJSON.data.message;

                        vm.$router.push({
                            name: 'login'
                        });
                    } else {
                        console.log("Error: " + jQxhr.responseJSON.statusDescription)
                    }
                }
            });


        },
        showTicketModal(ticketTypeid, defaultSubTypeID) {
            let vm = this

            vm.ticket_type_id = ticketTypeid;
            vm.ticket_sub_type_id = defaultSubTypeID
            vm.handleTicketSub()
            vm.$refs['create-ticket-modal'].show()
        },
        showTicketWithdrawModal(ticketTypeid, defaultSubTypeID, reference) {
            let vm = this
            vm.ticket_type_id = ticketTypeid;
            vm.ticket_sub_type_id = defaultSubTypeID
            vm.ticketReference = reference
            vm.handleTicketSub()
            vm.$refs['create-ticket-modal'].show()
        },
        hideTicketModal() {
            this.$refs['create-ticket-modal'].hide()
        },
        showModal() {
            if (this.statusProfile == 1) {
                this.actionStatus = "Block"
                this.userStatus = "-5"
            } else {
                this.userStatus = "1"
                this.actionStatus = "Activate"
            }
            this.$refs['my-modal'].show()
        },
        hideModal() {
            this.$refs['my-modal'].hide()
        },
        dateFilter: function(start, end) {

            var vm = this;
            vm.start = start;
            vm.end = end;
            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetableDeposit.refresh();

        },
        createdAt: function(value) {
            if (!value) {
                return '-';
            } else {
                return moment(value).format('h:mm a,DD MMM YYYY');
            }

        },

        updateProfileStatus() {
            let vm = this
            $.post({
                url: store.state.rootUrl + 'portal/v1/profile/status',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    'X-Token-Key': this.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    status: vm.userStatus,
                    profile_id: vm.profile_id
                }),
                success: function(response, status, jQxhr) {
                    if (response.data.code != 200) {
                        vm.updateStatus = true;
                        vm.updateMessage = response.data.message
                    } else {
                        vm.$refs['my-modal'].hide()
                        vm.search_profile()

                    }

                },
                error: function(jQxhr, status, error) {
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.updateStatus = true;
                    $('#verify').html('Next');
                    if (!statustext) {
                        vm.updateMessage = "An error occurred. Try again later.";
                    } else {
                        vm.updateMessage = statustext + " " + jQxhr.responseJSON.data.message;
                    }
                }
            });
        },

        createTicketType() {
            let vm = this
            $("#createPriority").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'tickets/v1/create',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    ticket_type_sub_id: vm.ticket_sub_type_id,
                    priority_id: vm.ticket_priority_id,
                    reference_id: vm.ticketReference,
                    ticket_brief: vm.description,
                    windowStart: vm.selectedDate + " " + vm.selectedTime,
                    msisdn: vm.searchProfile,
                    billAmount: vm.billAmount,
                    BillRefNumber: vm.BillRefNumber

                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $("#createPriority").text("Create Tickets");
                    if (response.data.code == 200) {
                        vm.hideTicketModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#createPriority").text("Create Priority");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },

        searchRecord: function() {
            this.moreParams.filter = this.search_match;
            this.$refs.vuetableDeposit.refresh();
        },
        search_profile() {
            let vm = this;
            vm.moreParams.filter = vm.searchProfile
            this.$refs.vuetableDeposit.refresh();

            $.get({
                url: store.state.rootUrl + "portal/v1/view/profiles",
                type: "GET",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: {
                    filter: vm.searchProfile,
                },
                success: function(response, status, jQxhr) {
                    vm.profile_data = true;
                    console.log("Response: " + JSON.stringify(response.data[0]))
                    vm.phone = response.data[0].mobile;
                    vm.email = response.data[0].email;
                    vm.balance = Number(response.data[0].wallet_balance);
                    vm.bonus = Number(response.data[0].wallet_bonus);
                    vm.deposit = Number(response.data[0].total_deposits);
                    vm.tickets = Number(response.data[0].total_tickets);
                    vm.withdraw = Number(response.data[0].totalWithdrawAmt);
                    vm.statusProfile = response.data[0].status;
                    vm.profile_id = response.data[0].profile_id
                },
                error: function(jQxhr, status, error) {

                }
            });


            vm.$refs.vuetableDeposit.refresh();
        },
        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData)
            this.$refs.pagination.setPaginationData(paginationData)
        },
        onPaginationDataDeposit(paginationData) {
            this.$refs.paginationInfoDeposit.setPaginationData(paginationData)
            this.$refs.paginationDeposit.setPaginationData(paginationData)
        },
        onPaginationDataTickets(paginationData) {
            this.$refs.paginationInfoTickets.setPaginationData(paginationData)
            this.$refs.paginationTickets.setPaginationData(paginationData)
        },
        onPaginationDataTransactions(paginationData) {
            this.$refs.paginationInfoTransactions.setPaginationData(paginationData)
            this.$refs.paginationTransactions.setPaginationData(paginationData)
        },
        onPaginationDataWithdraws(paginationData) {
            this.$refs.paginationInfoWithdraws.setPaginationData(paginationData)
            this.$refs.paginationWithdraws.setPaginationData(paginationData)
        },
        onPaginationDataSpinWheel(paginationData) {
            this.$refs.paginationInfoSpinWheel.setPaginationData(paginationData)
            this.$refs.paginationSpinWheel.setPaginationData(paginationData)
        },
        onPaginationDataAviator(paginationData) {
            this.$refs.paginationInfoAviator.setPaginationData(paginationData)
            this.$refs.paginationAviator.setPaginationData(paginationData)
        },
        onPaginationDataPickbox(paginationData) {
            this.$refs.paginationInfoPickbox.setPaginationData(paginationData)
            this.$refs.paginationPickbox.setPaginationData(paginationData)
        },
        onPaginationDataOutbox(paginationData) {
            this.$refs.paginationInfoOutbox.setPaginationData(paginationData)
            this.$refs.paginationOutbox.setPaginationData(paginationData)
        },
        onChangePageDeposit(page) {
            this.$refs.vuetableDeposit.changePage(page);
        },

        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },
        onChangePageTransactions(page) {
            this.$refs.vuetableTransactions.changePage(page);
        },
        onChangePageTickets(page) {
            this.$refs.vuetableTickets.changePage(page);
        },
        onChangePageWithdraws(page) {
            this.$refs.vuetableWithdraws.changePage(page)
        },
        onChangePageSpinWheel(page) {
            this.$refs.vuetableSpinWheel.changePage(page)
        },
        onChangePageAviator(page) {
            this.$refs.vuetableAviator.changePage(page)
        },
        onChangePagePickbox(page) {
            this.$refs.vuetablePickbox.changePage(page)
        },
        onChangePageOutbox(page) {
            this.$refs.vuetableOutbox.changePage(page)
        },

        onLoading() {
            this.loading = true
        },
        onLoaded() {
            this.loading = false

        }
    },
    created: function() {
        let vm = this;
        //$('.menu .item').tab();
        vm.selectedTab == 'default';
    },
    
    filters: {
        formartTicketStatus(value) {
            if (value == "1") {
                return "Unassigned"
            } else if (value == "2") {
                return "Assigned"
            } else if (value == "3") {
                return "Closed"
            } else {
                return "Progress"
            }
        },
        format_date(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD')
            } else {
                return ""
            }
        },
        formatAmount(value) {
            return numeral(value).format("0,0.00");
        },
        formatNumber(value) {
            return numeral(value).format("0,0");
        },
        formartStatus(value) {
            if (value == "1") {
                return "Active"
            } else if (value == "2") {
                return "Inactive"
            } else if (value == "-5") {
                return "Blocked"
            } else {
                return "Unregistered"
            }
        },
        formatStatusPayment(value) {
            if (value == "0") {
                return "Success"
            } else if (value == "1") {
                return "Insufficient Balance"
            } else if (value == "-5") {
                return "Refunded"
            } else {
                return "Failed"
            }
        },
        format_date_from(value) {
            if (value) {
                return moment(String(value)).fromNow();
            } else {
                return ""
            }
        },
    },


}
</script>